import {uiMsg} from '../utils/Languages';
import React, {Component} from 'react';
import {observer} from 'mobx-react';
import * as LoginHelper from '../utils/LoginHelper';
import AppModel from '../DataModel/AppModel';

import {List, ListItem, MakeSelectable} from 'material-ui/List';
import Divider from 'material-ui/Divider';
import Drawer from 'material-ui/Drawer';

// Icons in use
import Group from 'material-ui/svg-icons/social/group-add';
import Person from 'material-ui/svg-icons/social/person';
import Settings from 'material-ui/svg-icons/action/settings';
import Supervisor from 'material-ui/svg-icons/action/supervisor-account';
import Exit from 'material-ui/svg-icons/action/exit-to-app';
import Room from 'material-ui/svg-icons/action/room';
import Job from 'material-ui/svg-icons/action/restore';
import Home from 'material-ui/svg-icons/action/home';
import Web from 'material-ui/svg-icons/av/web';
import Trash from 'material-ui/svg-icons/action/delete';
import Machine from 'material-ui/svg-icons/action/settings-remote';
import ChartIcon from 'material-ui/svg-icons/editor/insert-chart';
import CallIcon from 'material-ui/svg-icons/communication/call';
import Business from 'material-ui/svg-icons/communication/business';
import PhoneIcon from 'material-ui/svg-icons/hardware/phone-android';
import Description from 'material-ui/svg-icons/action/description'
import Tethering from 'material-ui/svg-icons/device/wifi-tethering';
import SimCardIcon from 'material-ui/svg-icons/hardware/sim-card';

import {white} from 'material-ui/styles/colors';

let SelectableList = MakeSelectable(List);

export default
@observer class RuiNavigation extends Component {

  static contextTypes = {
    router: React.PropTypes.object
  }

  handleUpdateSelectedIndex(e,index) {
    // Updating the selectedNavLinkIndex which causes the
    // selected navlink to be (and stay) highlighted
    AppModel.uiSession.showNavigation=false;
    if(index=="logout") {
      var history = this.context.router;
      LoginHelper.logout(history);
      LoginHelper.login(history);
      return;
    }
    AppModel.selectedNavLinkIndex = index;
    this.context.router.push('/'+index);
  }

  // The selectable list does not change when clicking on the already
  // selected entry, to this is a hack to allow users to go back to the
  // main page for a sub-section, even if they are already in a sub-page
  // of that section.
  topNavigate(index) {
    return function() {
      return this.handleUpdateSelectedIndex(null,index);
    }
  }

  changeRequest(arg) {
    AppModel.uiSession.showNavigation = arg;
  }

  render() {
    var zIndexStyle={};
    if(AppModel.uiSession.fixedNavigation) {
      zIndexStyle={
        'zIndex':'1000',
        'marginTop':'64px',
        'position':'absolute',
        'height':'calc(100vh - 64px)'
      };
    }
    return (
    <Drawer open={AppModel.uiSession.navigationShowing}
             onRequestChange={this.changeRequest.bind(this)}
             docked={AppModel.uiSession.fixedNavigation}
             containerStyle={zIndexStyle}
             >
      <SelectableList
          value={AppModel.selectedNavLinkIndex}
          onChange={this.handleUpdateSelectedIndex.bind(this)} >
        <ListItem primaryText={uiMsg('N_HOME',"Home")}
                  value={"home"}
                  leftIcon={<Home />}
          />
        <ListItem primaryText={uiMsg('N_JOBS',"Jobs")}
                  value={"jobs"}
                  onTouchTap={this.topNavigate("jobs").bind(this)}
                  leftIcon={<Job />}
          />
        <ListItem primaryText={uiMsg('N_MACHINES',"Machines")}
                  value={"machines"}
                  onTouchTap={this.topNavigate("machines").bind(this)}
                  leftIcon={<Machine />}
          />
        <ListItem primaryText={uiMsg('N_ROOMS',"Rooms")}
                  value={"rooms"}
                  onTouchTap={this.topNavigate("rooms").bind(this)}
                  leftIcon={<Room />}
        />
        <ListItem primaryText={uiMsg('N_SETTINGS',"Settings")}
                  value={`settings/${AppModel.id_customer}/${AppModel.id_user}`}
                  leftIcon={<Settings />}
          />
        <ListItem primaryText={uiMsg('N_VERIFY_PHONE',"Verify phone number")}
                  value={`confirm_phone/${AppModel.id_customer}/${AppModel.id_user}`}
                  leftIcon={<PhoneIcon />}
                  style={AppModel.userInfo
                    && AppModel.userInfo.phone
                    && !AppModel.userInfo.phone_verified ?
                     {color:'red', fontWeight:'bold'}:
                     {display:'none'}}
          />
        <ListItem primaryText={uiMsg('N_DELETED',"Deleted")}
                  value={"deletions"}
                  leftIcon={<Trash />}
          />
        <ListItem primaryText={uiMsg('N_USER_MANUAL',"User Manual")}
                value={"user_manual"}
                leftIcon={ <Web />}
          />
        <ListItem primaryText={uiMsg('N_LOGOUT',"Logout")}
                  value={"logout"}
                  leftIcon={<Exit />}
          />
        <ListItem primaryText={uiMsg('N_SUPPORT',"Support")}
                  value={"support"}
                  style={{marginTop:'1em',
                          marginBottom:'1em',
                          backgroundColor:'black',
                          color:'white'}}
                  leftIcon={ <CallIcon color={white} />}
          />

        <ListItem primaryText={uiMsg('N_LOGIN_AS',"Login as ..")}
                  value={"impersonate"}
                  leftIcon={<Supervisor />}
                  style={AppModel.canImpersonateUsers ? {}:{display:'none'}}
          />
        <ListItem primaryText={uiMsg('N_CUSTOMERS',"Customers")}
                    value={"customers"}
                    leftIcon={<Business />}
                    onTouchTap={this.topNavigate("customers").bind(this)}
                    style={AppModel.canAddNewCustomers ? {}:{display:'none'}}
          />
        <ListItem primaryText={uiMsg('N_USER_ADMIN',"User admin")}
                  value={"user_admin"}
                  leftIcon={<Group />}
                  onTouchTap={this.topNavigate("user_admin").bind(this)}
                  style={AppModel.canAdminUsers ? {}:{display:'none'}}
          />
        <ListItem primaryText={uiMsg('N_MACHINE_ADMIN',"Machine Admin")}
                  value={"machine_admin"}
                  leftIcon={<Machine />}
                  onTouchTap={this.topNavigate("machine_admin").bind(this)}
                  style={AppModel.canAdminCustomers ? {}:{display:'none'}}
          />
        <ListItem primaryText={uiMsg('N_AUDIT_LOG', "Audit log")}
                  value={"audit-log"}
                  leftIcon={<Description/>}
                  style={AppModel.isSystemAdmin ? {} : {display: 'none'}}
        />
        <ListItem primaryText={uiMsg('N_BEACONS',"Beacons")}
                  value={"beacons"}
                  onTouchTap={this.topNavigate("beacons").bind(this)}
                  leftIcon={<Tethering />}
                  style={AppModel.isSystemAdmin ? {} : {display: 'none'}}
        />
        <ListItem primaryText={uiMsg('N_SIMCARDS',"SIM Cards")}
                  value={"simcards"}
                  onTouchTap={this.topNavigate("simcards").bind(this)}
                  leftIcon={<SimCardIcon />}
                  style={AppModel.isSystemAdmin ? {} : {display: 'none'}}
        />
        <ListItem primaryText={`Version ${AppModel.version()}`} disabled={true} style={{textAlign: 'center', color: 'gray'}}/>
      </SelectableList>
     
      </Drawer>
  )}
}



/** WEBPACK FOOTER **
 ** ./src/components/RuiNavigation.jsx
 **/